import { useCallback } from "react";
import useAuthService from "./useAuthService";
import { apiUrl } from "./config";
import useNotification from "../components/notification/useNotifications";


export default function useApiHelper() {
  const { getUser, refreshToken } = useAuthService();
  const { addNotification } = useNotification();
  // const apiUrl = "https://estatetrack-api.azurewebsites.net";
  // const apiUrl = "https://localhost:7259";

  function handleAuthRepsonse(res) {
    return res.text().then((text) => {
      const data = text && JSON.parse(text);
      if (!res.ok) {

        if (res.status === 401) {
          refreshToken();
        }

        if (res.status === 503 && data && data.maintenance) {
          const message = data.message || "Read-only for maintenance.";

          console.error(
            `Resource API Error: ${res.url} - ${res.status} ${res.statusText}`
          );

          addNotification({
            variant: "error",
            primaryText: message,
          });

          return Promise.reject({ maintenance: true, message });
        }

        console.error(
          `Resource API Error: ${res.url} - ${res.status} ${res.statusText}`
        );
        return Promise.reject(data);
      } else {
        return data;
      }
    });
  }

  const authHeader = () => {
    let user = getUser();

    if (user.identity) {
      return { Authorization: `Bearer ${user.identity.jwtToken}` };
    }
  };

  const buildPath = (path) => {
    return `${apiUrl}/api${path}`;
  };

  const get = useCallback(async (path) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json", ...authHeader() },
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  const post = useCallback(async (path, data) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(data),
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  const put = useCallback(async (path, data) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(data),
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  const patch = useCallback(async (path, data) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(data),
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  const del = useCallback(async (path, data) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(data),
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  const formData = useCallback(async (path, data) =>
    new Promise((resolve, reject) => {
      let requestOptions = {
        method: "POST",
        headers: { ...authHeader() },
        body: data,
      };

      return fetch(buildPath(path), requestOptions)
        .then(handleAuthRepsonse)
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }), []);

  return {
    get,
    post,
    put,
    patch,
    del,
    formData,
  };
}
